import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { FilterFormValues } from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

interface TextInputBlockProps {
  name: keyof FilterFormValues;
  title: string;
  placeholder?: string;
}

export const TextInputBlock = ({
  name,
  title,
  placeholder
}: TextInputBlockProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>{t(title)}</h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange } }) => (
            <Input
              type="text"
              value={(value as string | null | undefined) ?? ""}
              placeholder={placeholder}
              onChange={onChange}
            />
          )}
        />
      </div>
    </div>
  );
};
